import React, { useRef, useState, useEffect, act, useMemo, useCallback } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import {
  ClearSeekFlag,
  LoadVideoUrl,
  SetControllerToggle,
  SetVideoControl,
  UpdateVideoTime,
} from "../redux/actions/controlAction";
import { connect, useSelector } from "react-redux";
import VideoPlayer from "../components/VideoPlayerOld";
import {
  Text,
  TextInput,
  TouchableOpacity,
  useWindowDimensions,
} from "react-native";
import screenfull from "screenfull";
import { findDOMNode } from "react-dom";
import { AiOutlineFullscreen } from "react-icons/ai";
import { IoMdVolumeOff, IoMdVolumeHigh } from "react-icons/io";
import { Tooltip, Box } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  FaPause,
  FaPlay,
  FaArrowRight,
  FaStopwatch,
  FaSearch,
  FaEdit,
  FaVideo,
  FaCheckCircle,
  FaExclamationCircle,
  FaCheck,
  FaTimes,
  FaBell,
  FaArrowLeft,
  FaAngleDown,
  FaAngleUp,
} from "react-icons/fa";
import { saveReviewerSnapshot } from "../persistence/managers/ReviewerVersionManager";
import Duration from "../components/VideoPlayer(new)/DurationOld";
import {
  fetchMatchStringById,
  getReviewerFeedbackStrings,
  saveReviewerFeedback,
  updateMatchStatus,
} from "../config/mainRequest";
import useOnlineStatus from "../hooks/useOnlineStatus";
import OfflineNotice from "../components/OfflineNotice";

import { useHistory, useParams } from "react-router-dom";
import Logo from "../assets/Logo";
import toast, { useToasterStore } from "react-hot-toast";
import { Button, CircularProgress, IconButton, Stack, Typography } from "@mui/material";
import { ArrowBack, OpenInNew, Groups } from "@mui/icons-material";
import LineupPopup from "../components/LineupPopup";
import ReviewHistoryDropdown from "../components/ReviewHistoryDropdown";
import { v4 as uuidv4 } from "uuid";
import { FlatList, View } from "react-native-web";
import { useQuery, useQueryClient } from "react-query";
import { AutoSizer, CellMeasurer, List } from "react-virtualized";
import { CellMeasurerCache } from "react-virtualized";
import { EVENT_MAP } from "../constant/positionList";
import { trackEvent } from "../utils/mixpanel";
import { trackGA } from "../utils/ga";

// Waits between automatic retries of a failed review save (3 retries).
const SAVE_RETRY_DELAYS_MS = [1000, 2000, 4000];
const OFFLINE_MESSAGE = "Reviewing needs an internet connection. Reconnect to continue.";

const withRetries = async (attempt) => {
  let lastError;
  for (let i = 0; i <= SAVE_RETRY_DELAYS_MS.length; i += 1) {
    try {
      return await attempt();
    } catch (err) {
      lastError = err;
      if (!navigator.onLine || i === SAVE_RETRY_DELAYS_MS.length) break;
      await new Promise((resolve) => setTimeout(resolve, SAVE_RETRY_DELAYS_MS[i]));
    }
  }
  throw lastError;
};

const ReviewPortal = (props) => {
  const isOnline = useOnlineStatus();
  const { UpdateVideoTime, SetVideoControl, videoUrl, all_matches } = props;
  const { matchId } = useParams();
  const matchDetails = (props.all_matches || []).find(
    (match) => String(match.id) === String(matchId)
  );

  const matchAnalystId =
    matchDetails?.analyst_details[matchDetails?.analyst_details.length - 1]?.id;

  const { analystId, token, role } = useSelector((state) => ({
    analystId: state.auth.analyst_id,
    token: state.auth.token,
    role: state.auth.accountRole,
  }));

  // With several reviewers, each one's feedback is stored under their own id;
  // the first reviewer is only used when the logged-in user isn't a reviewer.
  const reviewerId =
    (matchDetails?.reviewer_details ?? []).find((r) => String(r.id) === String(analystId))?.id ??
    matchDetails?.reviewer_details?.[0]?.id;

  // Google Analytics helper — every event carries shared context for the screen.
  const track = useCallback(
    (action, extra = {}) =>
      trackGA(action, {
        screen: "review_portal",
        match_id: matchId,
        user_id: analystId,
        role,
        ...extra,
      }),
    [matchId, analystId, role]
  );

  const [isDarkMode, setIsDarkMode] = useState(
    document.body.classList.contains("theme-dark"),
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDarkMode(document.body.classList.contains("theme-dark"));
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  const [playing, setPlaying] = useState(false);
  const [ready, setReady] = useState(false);
  const [layoutWidth, setLayoutWidth] = useState(window.innerWidth);
  const [speed, setSpeed] = useState(1);
  const [duration, setDuration] = useState(null);
  const [seeking, setSeeking] = useState(false);
  const [jumpTo, setJumpTo] = useState("");
  const [showControls, setShowControl] = useState(false);
  const [isMute, setIsMute] = useState(false);
  const [activeFilter, setActiveFilter] = useState("all");
  const playerRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const queryClient = useQueryClient();
  const [lineupPopupOpen, setLineupPopupOpen] = useState(false);
  const [eventStrings, setEventStrings] = useState([]);
  const eventStringsRef = useRef([]);
  const [transformedStrings, setTransformedStrings] = useState();
  const [isNotifying, setIsNotifying] = useState(false);
  const [isCompleting, setIsCompleting] = useState(false);
  const listRef = useRef(null);
  const [searchStringValue, setSearchStringValue] = useState("");
  const [upcomingNextIndex, setUpcomingNextIndex] = useState(-1);
  const { width } = useWindowDimensions();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [searchMatchIndexes, setSearchMatchIndexes] = useState([]);
  const [currentSearchIndex, setCurrentSearchIndex] = useState(-1);

  const isMobile = width < 850;
  const isYoutubeUrl = () => {
    if (matchDetails?.youtube_videos?.[0]?.url) {
      const hostname = new URL(matchDetails?.youtube_videos?.[0]?.url).hostname;
      return hostname.includes("youtube.com");
    }
    return false;
  };



  const handleSeekMouseDown = (e) => {
    setSeeking(true);
  };

  const handleSeekChange = (e) => {
    UpdateVideoTime(parseFloat(e.target.value));
  };

  const handleSeekMouseUp = (e) => {
    setSeeking(false);
    playerRef.current.seekTo(parseFloat(e.target.value));
    track("review_portal_video_seek", { seek_to: parseFloat(e.target.value) });
  };

    // limit toast to a max of 3
  const { toasts } = useToasterStore();

  const TOAST_LIMIT = 3;

  useEffect(() => {
    toasts
      .filter((t) => t.visible)
      .filter((_, i) => i >= TOAST_LIMIT)
      .forEach((t) => toast.dismiss(t.id));
  }, [toasts]);


  const full = () => {
    track("review_portal_fullscreen");
    if (screenfull.isEnabled) {
      screenfull.request(findDOMNode(playerRef.current));
    }
  };

  // Fetch reviewer strings first
  const { data: reviewStrings } = useQuery({
    queryKey: ["getReviewerStrings", matchId, reviewerId ?? matchAnalystId],
    queryFn: () =>
      getReviewerFeedbackStrings({
        matchId,
        token,
        reviewerId: reviewerId ?? matchAnalystId,
        analystId: matchAnalystId,
      }),
  });

  useEffect(() => {
    // Mixpanel – screen entry
    trackEvent().track('entered_review_screen', { match_id: matchId });
    // Google Analytics – screen view
    track("review_portal_screen_view");
  }, [matchId, track]);

  useEffect(() => {
    const initializeEventStrings = async () => {
      try {
        // Fetch match strings first
        const matchResult = await fetchMatchStringById(
          Number(matchId),
          "",
          token
        );

        if (!matchResult?.temp_string) {
          toast.error("No strings found for this match");
          return;
        }

        // Parse match strings
        const matchStrings = matchResult.temp_string
          .split(",")
          .map((str) => str.trim())
          .filter((str) => str.length > 0);

        // Create a map from review strings for quick lookup
        const reviewStatusMap = new Map();

        if (
          reviewStrings &&
          reviewStrings.string_details &&
          Object.keys(reviewStrings.string_details).length > 0
        ) {
          // Review strings are already in full format (not nested)
          Object.entries(reviewStrings.string_details).forEach(
            ([fullString, details]) => {
              reviewStatusMap.set(fullString, {
                status: details.string_status,
                comments: details.comments,
              });
            }
          );
        }

        console.log(reviewStatusMap, "REVIEW STSTUAS MAP");

        // Map match strings with review status
        const mappedStrings = matchStrings.map((str, index) => {
          const reviewData = reviewStatusMap.get(str);

          let status;
          let error = null;
          let isFixed = false;

          if (reviewData !== undefined) {
            // Use review status if available
            if (reviewData.status === 0) {
              status = "error";
              error = reviewData.comments;
            } else if (reviewData.status === 1) {
              // Treat "fixed" status as upcoming for re-review
              status = "upcoming";
              isFixed = true;
              error = reviewData.comments;
            } else if (reviewData.status === 2) {
              status = "reviewed";
            } else {
              // Unknown status, treat as upcoming
              status = "upcoming";
            }
          } else {
            // No review data, use default logic
            status = "upcoming";
          }

          return {
            id: uuidv4(),
            value: str,
            status,
            isFixed: isFixed || false,
            error,
          };
        });

        // Find first upcoming string (includes new strings and fixed errors) and set as current
        const firstPendingIndex = mappedStrings.findIndex(
          (s) => s.status === "upcoming"
        );

        if (firstPendingIndex !== -1) {
          // There are still strings to review (either new or fixed)
          mappedStrings[firstPendingIndex].status = "current";
        }
        // If no upcoming strings found, don't set any as current
        // This means all strings are either "reviewed" or "error" and review is complete

        setEventStrings(mappedStrings);
      } catch (error) {
        console.error("Failed to initialize event strings", error);
        toast.error("Failed to load match data");
      }
    };

    if (matchId && analystId && token) {
      initializeEventStrings();
    }
  }, [matchId, analystId, token, reviewStrings]);

  console.log(eventStrings, "CHECK");

  const handleMute = () => {
    track("review_portal_video_mute", { muted: !isMute });
    setIsMute(!isMute);
  };

  const cache = useRef(
    new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 120,
    })
  );

  useEffect(() => {
    cache.current.clearAll();
    if (listRef.current) {
      listRef.current.forceUpdateGrid();
      // listRef.current.recomputeRowHeights();
    }
  }, [eventStrings]);

  const jumpManually = (str) => {
    const jumpInputList = str?.split(":");
    if (jumpInputList.length < 3) {
      return;
    }
    const totalSecends =
      parseInt(jumpInputList[0]) * 60 * 60 +
      parseInt(jumpInputList[1]) * 60 +
      parseInt(jumpInputList[2]);
    playerRef.current.seekTo(parseFloat(totalSecends));
    setPlaying(true);
    setJumpTo("");
    track("review_portal_jump_to_time", { time: str });
  };

  // Keep a live ref of the review list so post-save snapshots read fresh state.
  useEffect(() => {
    eventStringsRef.current = eventStrings;
  }, [eventStrings]);

  // Version snapshots are keyed by the logged-in reviewer. They are saved
  // locally + mirrored to Firestore for backup; the history is viewed only in
  // the management Version History screen, never here.
  const snapshotKey = { matchId, reviewerId: analystId };

  const updateTag = async (id, newValue) => {
    if (!navigator.onLine) {
      toast.error(`You're offline. ${OFFLINE_MESSAGE}`);
      return;
    }
    // Kept so a review that can't be saved is undone on screen too.
    const listBeforeReview = eventStringsRef.current;
    // Mixpanel – reviewer actions per status
    if (newValue.status === 'reviewed') {
      trackEvent().track('reviewer_marked_reviewed', { match_id: matchId, string: newValue.value });
    } else if (newValue.status === 'error') {
      trackEvent().track('reviewer_marked_error', { match_id: matchId, string: newValue.value, error_comment: newValue.error ?? '' });
    } else if (newValue.status === 'current') {
      trackEvent().track('reviewer_edit_mode', { match_id: matchId, string: newValue.value });
    }

    // Google Analytics – reviewer actions per status
    if (newValue.status === "reviewed") {
      track("review_portal_mark_reviewed", { string: newValue.value });
    } else if (newValue.status === "error") {
      track("review_portal_mark_error", { string: newValue.value, error_comment: newValue.error ?? "" });
    } else if (newValue.status === "current") {
      track("review_portal_edit_mode", { string: newValue.value });
    }

    setEventStrings((prev) => {
      const updated = prev.map((item) =>
        item.id === id ? { ...item, ...newValue } : item
      );

      const oldItem = prev.find((s) => s.id === id);

      // Check if this is an edit action (making a reviewed/error string current again)
      const isEditingToReview =
        (oldItem.status === "error" || oldItem.status === "reviewed") &&
        newValue.status === "current";

      // Check if this is editing an existing error comment
      const isEditingExistingError =
        oldItem.status === "error" && newValue.status === "error";

      // If we're just editing to review again or editing error comment, don't advance
      if (isEditingToReview || isEditingExistingError) {
        // Clear any other "current" strings before setting this one
        if (isEditingToReview) {
          return updated.map((item) =>
            item.id === id
              ? item // Keep the newly current item
              : item.status === "current"
              ? { ...item, status: "upcoming" } // Revert other current items to upcoming
              : item
          );
        }
        return updated;
      }

      // Only advance to next string if marking as reviewed or error (completing review)
      if (newValue.status === "reviewed" || newValue.status === "error") {
        const currentIndex = updated.findIndex((s) => s.id === id);
        for (let i = currentIndex + 1; i < updated.length; i++) {
          if (updated[i].status === "upcoming") {
            updated[i].status = "current";
            break;
          }
        }
      }

      return updated;
    });

    try {
      // Only save to backend if we're actually reviewing (not just switching to edit mode)
      if (newValue.status !== "current") {
        const string_status =
          newValue.status === "error" ? 0 : newValue.status === "fixed" ? 1 : 2;

        const comments = newValue.error ? newValue.error : "";

        await withRetries(() =>
          saveReviewerFeedback({
            token,
            body: {
              match_id: Number(matchId),
              reviewer_id: reviewerId ?? analystId,
              string_details: [
                {
                  string: newValue.value,
                  string_status,
                  comments,
                },
              ],
            },
          })
        );

        toast.success("Feedback saved!");

        // Capture a local version snapshot at each review save point.
        // eventStringsRef holds the post-update list (synced via effect).
        const label =
          newValue.status === "error"
            ? `Marked error: ${newValue.value}`
            : `Marked reviewed: ${newValue.value}`;
        saveReviewerSnapshot({
          ...snapshotKey,
          eventStrings: eventStringsRef.current,
          label,
        });
      }
    } catch (err) {
      // Not saved after 3 retries: undo the mark so the screen matches the server.
      setEventStrings(listBeforeReview);
      track("review_portal_save_failed", { error: String(err?.message || err).slice(0, 100) });
      toast.error(
        (t) => (
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span>
              {navigator.onLine
                ? "Review not saved, so it was undone."
                : "You're offline, so this review was not saved and was undone."}
            </span>
            <Button
              size="small"
              onClick={() => {
                toast.dismiss(t.id);
                updateTag(id, newValue);
              }}
              sx={{ textTransform: "none", fontWeight: 700 }}
            >
              Retry
            </Button>
          </span>
        ),
        { duration: 10000 }
      );
    }
  };

  useEffect(() => {
    const index = filteredData.findIndex((item) => item.status === "current");

    if (index !== -1 && listRef.current) {
      requestAnimationFrame(() => {
        cache.current.clear(index);
        // listRef.current.scrollToRow(index);
        setUpcomingNextIndex(index);
      });
    }
  }, [eventStrings]);

  const getNextCurrentIndex = () => {
    return eventStrings.findIndex((item) => item.status === "current");
  };

  const focusNextError = () => {
    const currentIndex = eventStrings.findIndex((e) => e.status === "current");
    if (currentIndex === -1) {
      toast.error("No active item to mark error");
      return;
    }
    track("review_portal_open_error_input");
    setEventStrings((prev) =>
      prev.map((it, i) =>
        i === currentIndex
          ? { ...it, _openErrorInput: true }
          : { ...it, _openErrorInput: false }
      )
    );
  };


  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!playerRef.current) return;

      // system shortcuts
      // eslint-disable-next-line default-case
      switch (e.key) {
        case " ":
          e.preventDefault();
          track("review_portal_video_playpause", { playing: !props.videoControl, source: "keyboard" });
          props.SetVideoControl(!props.videoControl);
          return;

        case "ArrowRight":
          track("review_portal_video_seek", { source: "keyboard", direction: "forward" });
          playerRef.current.seekTo(props.videoTime + 5);
          return;

        case "ArrowLeft":
          track("review_portal_video_seek", { source: "keyboard", direction: "backward" });
          playerRef.current.seekTo(props.videoTime - 5);
          return;

        case "e":
        case "E":
          e.preventDefault();
          focusNextError();
          return;

        case "m":
        case "M":
          track("review_portal_video_mute", { source: "keyboard" });
          setIsMute((prev) => !prev);
          return;
      }

      const currentItem = eventStrings.find((s) => s.status === "current");
      if (!currentItem) return;

      if (
        (e.key === "n" || e.key === "N") &&
        searchStringValue === "" &&
        (activeFilter === "all" ||
          activeFilter === "pending" ||
          activeFilter === "fixed")
      ) {
        updateTag(currentItem.id, {
          value: currentItem.value,
          status: "reviewed",
          error: null,
        });

        // requestAnimationFrame(() => {
        //   const nextIndex = getNextCurrentIndex();
        //   if (nextIndex !== -1 && activeFilter !== "pending") {
        //     // cache.current.clear(nextIndex);
        //     // listRef.current.recomputeRowHeights(nextIndex);
        //     listRef.current.scrollToRow(nextIndex);
        //   }
        // });

        toast.success("Marked as Reviewed");
        return;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    props.videoControl,
    props.videoTime,
    eventStrings,
    searchStringValue,
    activeFilter,
  ]);

  const handleErrorInputToggle = (index) => {
    cache.current.clear(index);
    if (listRef.current) {
      listRef.current.forceUpdateGrid();
    }
  };

  const handleDeployToTMS = async () => {
    if (!navigator.onLine) {
      toast.error(`You're offline. ${OFFLINE_MESSAGE}`);
      return;
    }
    // Mixpanel
    trackEvent().track('reviewer_deploy_to_tms', { match_id: matchId });
    track("review_portal_deploy_to_tms");
    try {
      setIsCompleting(true);

      const res = await updateMatchStatus({
        match_id: Number(matchId),
        match_status: 7,
        token,
      });

      if (res?.response_data?.is_success) {
        toast.success("Match Status Updated!!");
      }
    } catch (err) {
      console.log(err);
      toast.error("Failed to Update Match Status!!");
    } finally {
      setIsCompleting(false);
    }
  };

  const handleNotifyAnalysts = async () => {
    if (!navigator.onLine) {
      toast.error(`You're offline. ${OFFLINE_MESSAGE}`);
      return;
    }
    // Mixpanel
    trackEvent().track('reviewer_notify_analysts', { match_id: matchId });
    track("review_portal_notify_analysts");
    try {
      setIsNotifying(true);

      const res = await updateMatchStatus({
        match_id: Number(matchId),
        match_status: 9,
        reviewer_id: Number(analystId), // logged in user
        token,
      });

      if (res?.response_data?.is_success) {
        toast.success("Match Status Updated!!");
        // Notifying records a new review round in the history.
        queryClient.invalidateQueries(["getReviewerFeedbackHistory", matchId]);
      }
    } catch (err) {
      console.log(err);
      toast.error("Failed to Update Match Status!!");
    } finally {
      setIsNotifying(false);
    }
  };

  const warningCount = transformedStrings?.filter(
    (item) => item.type === "warning"
  ).length;

  const errorCount = transformedStrings?.filter(
    (item) => item.type === "error"
  ).length;

  const formatTimeFromSeconds = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const details = all_matches?.find((m) => {
    return m.id.toString() === matchId;
  });

  const filteredData = useMemo(() => {
    if (!eventStrings) return [];

    return eventStrings.filter((item) => {
      // Handle filter logic
      if (activeFilter === "all") return true;
      if (activeFilter === "pending") {
        return item.status === "upcoming" || item.status === "current";
      }
      if (activeFilter === "fixed") {
        return item.isFixed === true;
      }
      return item.status === activeFilter;
    });
  }, [eventStrings, activeFilter]);

  // clear if filter changes
  useEffect(() => {
    setCurrentSearchIndex(-1);
    setSearchMatchIndexes([]);
  }, [activeFilter]);
  // search and filter but dont filter out the main array just being used fpor traversal
  useEffect(() => {
    if (!searchStringValue || !filteredData?.length) {
      setSearchMatchIndexes([]);
      setCurrentSearchIndex(-1);
      return;
    }

    const search = searchStringValue.toLowerCase();

    const matches = filteredData.reduce((acc, item, index) => {
      const parts = item.value?.split("-") || [];
      const timestamp = (parts[6] || "").toLowerCase();

      if (
        item.value.toLowerCase().includes(search) ||
        timestamp.includes(search)
      ) {
        acc.push(index);
      }

      return acc;
    }, []);

    setSearchMatchIndexes(matches);
    setCurrentSearchIndex(matches.length ? matches[0] : -1);
  }, [searchStringValue, filteredData]);

  useEffect(() => {
    if (currentSearchIndex !== -1 && listRef.current) {
      listRef.current.scrollToRow(currentSearchIndex);
    }
  }, [currentSearchIndex]);

  // Track searches once the user pauses typing (debounced), not per keystroke.
  useEffect(() => {
    const q = searchStringValue.trim();
    if (!q) return;
    const t = setTimeout(() => {
      track("review_portal_search", { query: q, matches: searchMatchIndexes.length });
    }, 800);
    return () => clearTimeout(t);
  }, [searchStringValue, searchMatchIndexes.length, track]);

  // scrollToIndex from <list/> being used
  const goToNextSearchMatch = () => {
    if (!searchMatchIndexes.length) return;
    const currentPos = searchMatchIndexes.indexOf(currentSearchIndex);
    const nextPos = (currentPos + 1) % searchMatchIndexes.length;
    setCurrentSearchIndex(searchMatchIndexes[nextPos]);
    track("review_portal_search_next");
  };

  const goToPrevSearchMatch = () => {
    if (!searchMatchIndexes.length) return;
    const currentPos = searchMatchIndexes.indexOf(currentSearchIndex);
    const prevPos =
      (currentPos - 1 + searchMatchIndexes.length) % searchMatchIndexes.length;
    setCurrentSearchIndex(searchMatchIndexes[prevPos]);
    track("review_portal_search_prev");
  };

  if (isLoading) {
    return (
      <Stack
        style={{
          width: "100%",
          height: "100%",
          zIndex: 10,
          backgroundColor: "var(--surface-1)",
          position: "absolute",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Logo />
        <Typography style={{ color: "var(--text-1)", fontFamily: "Source Sans 3" }}>
          loading setup...
        </Typography>
      </Stack>
    );
  }

  return (
    <div>
      {/* Header */}
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ height: 56, px: 2, borderBottom: "1px solid var(--border-1)", backgroundColor: "var(--surface-1)", position: "sticky", top: 0, zIndex: 10 }}>
        <IconButton onClick={() => history.goBack()} size="small" sx={{ color: "var(--text-2)", borderRadius: "6px", width: 30, height: 30, "&:hover": { backgroundColor: "var(--surface-2)" } }}>
          <ArrowBack sx={{ fontSize: 18 }} />
        </IconButton>
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "rgba(232,108,0,1)" }}>#{matchId}</Typography>
          <Typography sx={{ fontSize: "14px", color: "var(--text-1)" }}>
            {matchDetails?.team_a_details?.name} vs {matchDetails?.team_b_details?.name}
          </Typography>
        </Stack>
        <Box sx={{ width: 30 }} />
      </Stack>

      {!isOnline && <OfflineNotice title="You're offline." message={OFFLINE_MESSAGE} />}

      {/* Cards */}
      <Stack direction={{ xs: "column", md: "row" }} gap={1.5} sx={{ px: 2, pt: 2, pb: 0 }}>
        {/* Team Card */}
        <Stack direction="row" alignItems="center" sx={{ flex: 1.4, p: 2, backgroundColor: "var(--surface-1)", border: "1px solid var(--border-1)", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
          <Stack flex={1} alignItems="center">
            <Typography sx={{ fontSize: "10px", color: "var(--text-2)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>Team A</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "var(--text-1)", mt: 0.5, textAlign: "center" }}>{matchDetails?.team_a_details?.name}</Typography>
          </Stack>
          <Typography sx={{ fontSize: "11px", color: "var(--text-2)", fontWeight: 500, px: 1 }}>vs</Typography>
          <Stack flex={1} alignItems="center">
            <Typography sx={{ fontSize: "10px", color: "var(--text-2)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>Team B</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "var(--text-1)", mt: 0.5, textAlign: "center" }}>{matchDetails?.team_b_details?.name}</Typography>
          </Stack>
        </Stack>

        {/* Analyst Card */}
        <Stack direction="row" alignItems="center" gap={1.5} sx={{ flex: 1.6, p: 2, backgroundColor: "var(--surface-1)", border: "1px solid var(--border-1)", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
          <Stack sx={{ width: 44, height: 44, borderRadius: "10px", backgroundColor: "rgba(12,157,65,0.12)", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <Typography sx={{ fontSize: "16px", fontWeight: 700, color: "#0C9D41" }}>{matchDetails?.analyst_details?.[0]?.id}</Typography>
          </Stack>
          <Stack>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "var(--text-1)" }}>{matchDetails?.analyst_details?.[0]?.name}</Typography>
            <Typography sx={{ fontSize: "10px", color: "var(--text-2)", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.3px" }}>Analyst ID & Name</Typography>
          </Stack>
        </Stack>

        {/* Elapsed Time Card */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ flex: 1, p: 2, backgroundColor: "var(--surface-1)", border: "1px solid var(--border-1)", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
          <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "var(--text-2)", textTransform: "uppercase", letterSpacing: "0.5px" }}>Elapsed Time</Typography>
          <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "rgba(232,108,0,1)", fontFamily: "monospace" }}>
            {formatTimeFromSeconds(details?.analysis_tat) || "00:00:00"}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          gap={1.5}
          onClick={() => history.push(`/match-details/${matchDetails?.id}`)}
          sx={{
            flex: 1,
            p: 2,
            backgroundColor: "var(--surface-1)",
            border: "1px solid var(--border-1)",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            cursor: "pointer",
            transition: "border-color 0.15s ease, box-shadow 0.15s ease",
            "&:hover": { borderColor: "rgba(232,108,0,0.5)", boxShadow: "0 4px 12px rgba(232,108,0,0.12)" },
          }}
        >
          <Stack>
            <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "var(--text-2)", textTransform: "uppercase", letterSpacing: "0.5px" }}>Match Details</Typography>
            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "var(--text-1)", mt: 0.25 }}>View full details</Typography>
          </Stack>
          <Stack sx={{ width: 36, height: 36, borderRadius: "10px", backgroundColor: "rgba(232,108,0,0.12)", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <OpenInNew sx={{ fontSize: 18, color: "rgba(232,108,0,1)" }} />
          </Stack>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          gap={1.5}
          onClick={() => setLineupPopupOpen(true)}
          sx={{
            flex: 1,
            p: 2,
            backgroundColor: "var(--surface-1)",
            border: "1px solid var(--border-1)",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            cursor: "pointer",
            transition: "border-color 0.15s ease, box-shadow 0.15s ease",
            "&:hover": { borderColor: "rgba(232,108,0,0.5)", boxShadow: "0 4px 12px rgba(232,108,0,0.12)" },
          }}
        >
          <Stack>
            <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "var(--text-2)", textTransform: "uppercase", letterSpacing: "0.5px" }}>Line Up</Typography>
            <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "var(--text-1)", mt: 0.25 }}>Quick view</Typography>
          </Stack>
          <Stack sx={{ width: 36, height: 36, borderRadius: "10px", backgroundColor: "rgba(232,108,0,0.12)", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <Groups sx={{ fontSize: 18, color: "rgba(232,108,0,1)" }} />
          </Stack>
        </Stack>
      </Stack>

      <LineupPopup
        open={lineupPopupOpen}
        onClose={() => setLineupPopupOpen(false)}
        matchId={matchDetails?.id}
        token={token}
      />

      <Stack direction="row" gap={1.5} sx={{ mx: 2, mt: 1.5 }}>
        <Stack direction="row" alignItems="center" gap={2} sx={{ flex: 7, minWidth: 0, px: 2, py: 1, backgroundColor: "var(--surface-1)", border: "1px solid var(--border-1)", borderRadius: "10px" }}>
          <Typography sx={{ fontSize: "12px", fontWeight: 500, color: "var(--text-2)", whiteSpace: "nowrap" }}>Load Custom Video URL</Typography>
          <Stack flex={1} />
          <Stack direction="row" sx={{ border: "1px solid var(--border-1)", borderRadius: "8px", overflow: "hidden" }}>
            <input type="text" placeholder="Paste match video url.." style={{ padding: "7px 12px", border: "none", outline: "none", fontSize: 12, backgroundColor: "var(--surface-2)", color: "var(--text-1)", width: 260 }} />
            <Box sx={{ backgroundColor: "rgba(232,108,0,1)", px: 1.5, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
              <FaSearch color="#fff" size={11} />
            </Box>
          </Stack>
        </Stack>
        <Box sx={{ flex: 3, minWidth: 0 }}>
          <ReviewHistoryDropdown
            matchId={matchId}
            token={token}
            reviewers={matchDetails?.reviewer_details ?? []}
          />
        </Box>
      </Stack>

      <div
        style={{
          width: isMobile && "100%",
          display: "flex",
          flexDirection: isMobile ? "column " : "row",
          gap: "5px",
          margin: "1rem",
        }}
      >
        <div
          style={{
            width: isMobile ? "100%" : "75%",
          }}
        >
          <div
            style={{
              width: "100%",
            }}
          >
            {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "1rem",
              }}
            >
              <Typography
                style={{ fontSize: 18, fontWeight: "600", marginBottom: 12 }}
              >
                Event Clip Tracker
              </Typography>
              <Typography
                style={{ fontSize: 12, color: "#FF5A1F", marginBottom: 12 }}
              >
                Verify Event String with video clip..
              </Typography>
            </div> */}
            <Stack style={styles.videoContainer}>
              <div style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10, overflow: "hidden" }}>
                <VideoPlayer
                  cref={playerRef}
                  url={matchDetails?.youtube_videos?.[0]?.url}
                  controls={showControls}
                  played={props.videoTime}
                  muted={isMute}
                  onProgress={(e) => {
                    !seeking && UpdateVideoTime(e);
                  }}
                  playing={props.videoControl}
                  onPause={() => {
                    SetVideoControl(false);
                  }}
                  onEnded={() => {
                    SetVideoControl(false);
                  }}
                  onPlay={() => {
                    SetVideoControl(true);
                  }}
                  onReady={() => {
                    setReady(true);
                  }}
                  playbackRate={speed}
                  onDuration={(t) => {
                    setDuration(t);
                  }}
                />
              </div>

              {ready && !isYoutubeUrl() && (
                <Stack style={styles.videoTimeline}>
                  <input
                    type="range"
                    value={props.videoTime}
                    style={{ width: "100%", borderWidth: 0 }}
                    min={0}
                    max={duration}
                    onMouseDown={handleSeekMouseDown}
                    onChange={handleSeekChange}
                    onMouseUp={handleSeekMouseUp}
                  />
                </Stack>
              )}

              {ready && (
                <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", alignItems: "center", gap: 8, backgroundColor: "var(--surface-1)", borderTop: "1px solid var(--border-1)", padding: "11px 16px", boxSizing: "border-box", width: "100%" }}>
                  {/* Left: Jump To + timestamp */}
                  <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                    <FaStopwatch size={11} color="var(--text-2)" />
                    <TextInput
                      style={{ width: "5.5rem", fontSize: "11px", border: "1px solid var(--border-1)", borderRadius: "5px", backgroundColor: "var(--surface-2)", color: "var(--text-1)", paddingVertical: "5px", paddingHorizontal: "6px", outline: "none", textAlign: "center" }}
                      onChangeText={setJumpTo}
                      defaultValue={jumpTo}
                      placeholder="HH:MM:SS"
                    />
                    <TouchableOpacity
                      disabled={jumpTo === ""}
                      onPress={() => jumpManually(jumpTo)}
                      style={{ width: 26, height: 26, borderRadius: 5, justifyContent: "center", alignItems: "center", backgroundColor: jumpTo ? "#FF5A1F" : "var(--surface-2)", border: "1px solid var(--border-1)" }}
                    >
                      <FaArrowRight size={9} color={jumpTo ? "#fff" : "var(--text-2)"} />
                    </TouchableOpacity>
                    {!isYoutubeUrl() && (
                      <>
                        <div style={{ width: 1, height: 18, background: "var(--border-1)", margin: "0 4px" }} />
                        <Duration seconds={props.videoTime} />
                      </>
                    )}
                  </div>

                  {/* Center: Play/Pause */}
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {!isYoutubeUrl() && (
                      <TouchableOpacity
                        onPress={() => { props.SetVideoControl(!props.videoControl); }}
                        style={{ flexDirection: "row", alignItems: "center", gap: 8, backgroundColor: "#FF5A1F", paddingHorizontal: "22px", paddingVertical: "10px", borderRadius: "8px" }}
                      >
                        {!props.videoControl ? <FaPlay color="#fff" size={14} /> : <FaPause color="#fff" size={14} />}
                        <Text style={{ fontSize: "15px", color: "#fff", fontWeight: "700" }}>
                          {!props.videoControl ? "Play" : "Pause"}
                        </Text>
                      </TouchableOpacity>
                    )}
                  </div>

                  {/* Right: Speed pills + fullscreen + mute */}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 5 }}>
                    {!isYoutubeUrl() && (
                      <div style={{ display: "flex", border: "1px solid var(--border-1)", borderRadius: 6, overflow: "hidden", flexShrink: 1 }}>
                        {[0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75].map((s, i) => (
                          <TouchableOpacity
                            key={s}
                            onPress={() => setSpeed(s)}
                            style={{ paddingHorizontal: "6px", paddingVertical: "5px", backgroundColor: speed === s ? "#FF5A1F" : "var(--surface-2)", borderRight: i < 6 ? "1px solid var(--border-1)" : "none", alignItems: "center", justifyContent: "center" }}
                          >
                            <Text style={{ fontSize: "10px", fontWeight: "600", color: speed === s ? "#fff" : "var(--text-2)" }}>
                              {s}x
                            </Text>
                          </TouchableOpacity>
                        ))}
                      </div>
                    )}
                    <TouchableOpacity
                      onPress={full}
                      style={{ width: 30, height: 30, flexShrink: 0, borderRadius: 5, justifyContent: "center", alignItems: "center", backgroundColor: "var(--surface-2)", border: "1px solid var(--border-1)" }}
                    >
                      <AiOutlineFullscreen color="var(--text-1)" size={15} />
                    </TouchableOpacity>
                    <TouchableOpacity
                      onPress={handleMute}
                      style={{ width: 30, height: 30, flexShrink: 0, borderRadius: 5, justifyContent: "center", alignItems: "center", backgroundColor: "var(--surface-2)", border: "1px solid var(--border-1)" }}
                    >
                      {isMute ? <IoMdVolumeOff color="var(--text-1)" size={15} /> : <IoMdVolumeHigh color="var(--text-1)" size={15} />}
                    </TouchableOpacity>
                  </div>
                </div>
              )}
            </Stack>
            <Stack sx={{ mt: 1.5, borderRadius: "12px", border: "1px solid var(--border-1)", overflow: "hidden", backgroundColor: "var(--surface-1)" }}>
              <Stack direction={{ xs: "column", md: "row" }} alignItems="stretch">
                {/* Event Details */}
                <Stack sx={{ flex: 1, p: 2, borderRight: { md: "1px solid var(--border-1)" }, borderBottom: { xs: "1px solid var(--border-1)", md: "none" } }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "var(--text-2)", textTransform: "uppercase", letterSpacing: "1px", mb: 1.5 }}>
                    Event Details
                  </Typography>
                  <InfoRow label="Errors" value={eventStrings.filter((item) => item.status === "error")?.length || 0} bgColor="#fdecea" textColor="#d32f2f" />
                  <InfoRow label="Reviewed" value={eventStrings.filter((item) => item.status === "reviewed")?.length || 0} bgColor="#e6f4ea" textColor="#2e7d32" />
                  <InfoRow label="Pending Review" value={eventStrings.filter((item) => item.status === "upcoming" || item.status === "current")?.length || 0} bgColor="#fff4cc" textColor="#f57c00" />
                  <InfoRow label="Total events tag" value={eventStrings.length || 0} bgColor="var(--surface-2)" textColor="var(--text-1)" bold />
                  <Typography sx={{ mt: 1, fontSize: "11px", color: "#d32f2f" }}>
                    Warning: Submission of the analysis is only permitted once all errors and warnings have been addressed.
                  </Typography>
                </Stack>

                {/* Actions */}
                <Stack sx={{ width: { xs: "100%", md: "300px" }, flexShrink: 0, p: 2, gap: 1.5 }}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "var(--text-2)", textTransform: "uppercase", letterSpacing: "1px", mb: 0.5 }}>
                    Actions
                  </Typography>
                  <Button
                    fullWidth
                    variant="contained"
                    disabled={
                      isNotifying ||
                      eventStrings.filter((item) => item.status === "error")?.length === 0 ||
                      eventStrings.filter((item) => item.status === "upcoming" || item.status === "current")?.length > 0
                    }
                    onClick={handleNotifyAnalysts}
                    sx={{ py: 1.5, borderRadius: "10px", textTransform: "none", fontSize: "14px", fontWeight: 700, backgroundColor: "rgba(232,108,0,1)", "&:hover": { backgroundColor: "rgba(200,93,0,1)" }, "&.Mui-disabled": { backgroundColor: "rgba(232,108,0,0.35)", color: "#fff" } }}
                  >
                    {isNotifying ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : <span style={{ display: "flex", alignItems: "center", gap: 8 }}><FaBell style={{ marginRight: 6 }} /> Notify Analysts</span>}
                  </Button>
                  <Button
                    fullWidth
                    variant="contained"
                    disabled={
                      isCompleting ||
                      !!eventStrings.filter((item) => item.status === "error")?.length ||
                      !!eventStrings.filter((item) => item.status === "upcoming" || item.status === "current")?.length
                    }
                    onClick={handleDeployToTMS}
                    sx={{ py: 1.5, borderRadius: "10px", textTransform: "none", fontSize: "14px", fontWeight: 700, backgroundColor: "#059669", "&:hover": { backgroundColor: "#047857" }, "&.Mui-disabled": { backgroundColor: "rgba(5,150,105,0.35)", color: "#fff" } }}
                  >
                    {isCompleting ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : <span style={{ display: "flex", alignItems: "center", gap: 6 }}>Mark As Complete <FaArrowRight style={{ marginLeft: 6 }} /></span>}
                  </Button>
                  {eventStrings.filter((item) => item.status === "error")?.length > 0 ? (
                    <Typography sx={{ fontSize: "12px", color: "#E02424" }}>
                      Warning: Submission of the analysis is only permitted once all errors and warnings have been addressed.
                    </Typography>
                  ) : (
                    <Typography sx={{ fontSize: "12px", color: "#2e7d32" }}>
                      ✓ All unresolved issues have been addressed. You may now proceed with the submission.
                    </Typography>
                  )}
                </Stack>
              </Stack>
            </Stack>
          </div>
        </div>
        <div
          style={{
            width: isMobile ? "100%" : "42%",
            // height: "60rem",
            height: isMobile && "80vh",
            overflow: isMobile ? "scroll" : "hidden",
            borderRadius: 8,
            backgroundColor: "var(--surface-1)",
            boxShadow: "0 4px 12px var(--border-1)",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "1rem 1rem 0rem 1rem",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
              <FilterButtons active={activeFilter} setActive={setActiveFilter} />
              <div style={{ display: "flex", gap: 6, flexShrink: 0, marginLeft: 8 }}>
                <button
                  title="Go to Top"
                  onClick={() => { if (listRef.current) { listRef.current.scrollToPosition(0); } }}
                  style={{ display: "flex", alignItems: "center", gap: 5, padding: "6px 12px", borderRadius: 8, border: "1px solid var(--border-1)", backgroundColor: "var(--surface-1)", color: "var(--text-2)", fontSize: 12, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" }}
                >
                  <FaArrowLeft style={{ transform: "rotate(90deg)" }} size={10} /> Top
                </button>
                <button
                  title="Go to Bottom"
                  onClick={() => { if (listRef.current) { listRef.current.scrollToRow(filteredData.length - 1); } }}
                  style={{ display: "flex", alignItems: "center", gap: 5, padding: "6px 12px", borderRadius: 8, border: "1px solid var(--border-1)", backgroundColor: "var(--surface-1)", color: "var(--text-2)", fontSize: 12, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" }}
                >
                  <FaArrowLeft style={{ transform: "rotate(270deg)" }} size={10} /> Bottom
                </button>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                marginTop: 10,
                marginBottom: 16,
                alignItems: "baseline",
              }}
            >
              <div
                style={{
                  flex: 1,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "var(--surface-2)",
                  borderRadius: 6,
                  padding: "8px 12px",
                  border: "1px solid var(--border-1)",
                }}
              >
                <FaSearch color="var(--text-2)" size={14} />
                <input
                  value={searchStringValue}
                  onChange={(e) => setSearchStringValue(e.target.value)}
                  placeholder="Search String by Timestamp"
                  style={{
                    flex: 1,
                    marginLeft: 8,
                    border: "none",
                    outline: "none",
                    backgroundColor: "transparent",
                    fontSize: 16,
                    color: "var(--text-1)",
                  }}
                />
                {searchStringValue && searchMatchIndexes.length > 0 && (
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: 12,
                        paddingRight: "6px",
                        borderRight: "1px solid #6B7280",
                        color: "#555",
                      }}
                    >
                      {searchMatchIndexes.indexOf(currentSearchIndex) + 1} /{" "}
                      {searchMatchIndexes.length}
                    </Typography>

                    <FaAngleUp
                      onClick={goToNextSearchMatch}
                      style={{
                        cursor: "pointer",
                      }}
                      color="#6B7280"
                      size={16}
                    />

                    <FaAngleDown
                      style={{
                        cursor: "pointer",
                      }}
                      color="#6B7280"
                      size={16}
                      onClick={goToPrevSearchMatch}
                    />
                    <FaTimes
                      size={16}
                      color="#6B7280"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSearchStringValue("");
                        if (listRef.current) {
                          listRef.current.scrollToPosition(scrollPosition);
                          // listRef.current.recomputeRowHeights(index);
                        }
                      }}
                    />
                  </Stack>
                )}
              </div>
              <LegendTooltipIcon />
            </div>
          </div>
          <div style={{ height: "87%" }}>
            {filteredData.length === 0 ? (
              <Stack
                style={{
                  padding: 16,
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                }}
              >
                <Typography style={{ color: "gray", fontSize: 16 }}>
                  {`No ${activeFilter} strings found`}
                </Typography>
              </Stack>
            ) : (
              <AutoSizer>
                {({ width, height }) => (
                  <List
                    ref={listRef}
                    width={width}
                    onScroll={({ scrollTop }) => {
                      setScrollPosition(scrollTop);
                    }}
                    height={height}
                    scrollToIndex={
                      !searchStringValue && currentSearchIndex === -1
                        ? upcomingNextIndex
                        : undefined
                    }
                    style={{ padding: "10px" }}
                    scrollToAlignment="start"
                    deferredMeasurementCache={cache.current}
                    rowCount={filteredData.length}
                    rowHeight={cache.current.rowHeight}
                    rowRenderer={({ index, key, style, parent }) => {
                      const item = filteredData[index];

                      return (
                        <CellMeasurer
                          key={key}
                          cache={cache.current}
                          parent={parent}
                          rowIndex={index}
                          columnIndex={0}
                        >
                          <div style={style}>
                            <EditableTag
                              key={item.id}
                              openErrorInputExternally={
                                item._openErrorInput || false
                              }
                              searchValue={searchStringValue}
                              getNextCurrentIndex={getNextCurrentIndex}
                              activeFilter={activeFilter}
                              listRef={listRef}
                              text={item.value}
                              type={item.status}
                              error={item.error}
                              isFixed={item.isFixed}
                              index={index}
                              isDarkMode={isDarkMode}
                              onChange={(newVal) => {
                                cache.current.clear(index);
                                updateTag(item.id, newVal);
                              }}
                              onErrorToggle={() =>
                                handleErrorInputToggle(index)
                              }
                              jumpManually={jumpManually}
                            />
                          </div>
                        </CellMeasurer>
                      );
                    }}
                  />
                )}
              </AutoSizer>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const InfoRow = ({ label, value, bgColor, textColor, bold }) => (
  <Stack
    style={{
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginVertical: 6,
      paddingBottom: 8,
      marginBottom: 8,
      borderBottom: "1px var(--border-1) solid",
    }}
  >
    <Typography
      style={{ fontSize: 16, color: "var(--text-1)", fontWeight: bold ? "700" : "400" }}
    >
      {label}
    </Typography>
    <Stack
      style={{
        backgroundColor: bgColor,
        paddingHorizontal: 10,
        paddingVertical: 4,
        borderRadius: 6,
        minWidth: 40,
        alignItems: "center",
      }}
    >
      <Typography style={{ color: textColor, fontWeight: "600" }}>
        {value}
      </Typography>
    </Stack>
  </Stack>
);

const EditableTag = ({
  text,
  isFixed,
  onChange,
  error,
  getNextCurrentIndex,
  activeFilter,
  searchValue,
  listRef,
  openErrorInputExternally,
  type = "current",
  jumpManually,
  onErrorToggle,
  isDarkMode,
}) => {
  const errorInputRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(text);
  const [showErrorInput, setShowErrorInput] = useState(false);
  const [errorText, setErrorText] = useState(error || "");

  useEffect(() => {
    if (showErrorInput && errorInputRef.current) {
      errorInputRef.current.focus();
    }
  }, [showErrorInput]);

  useEffect(() => {
    if (openErrorInputExternally) {
      setShowErrorInput(true);
      setErrorText(error || "");
    }
  }, [openErrorInputExternally]);

  const getEventFromString = (str) => {
    const parts = str?.split("-");
    if (parts?.length < 3) return null;
    const eventCode = `${parts?.[2]}-${parts?.[3]}`;
    return EVENT_MAP[eventCode] || null;
  };

  useEffect(() => {
    setValue(text);
  }, [text]);

  const highlightText = (text, search) => {
    if (!search) return text;

    const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escaped})`, "ig");

    return text.split(regex).map((part, i) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <span
          key={i}
          style={{
            backgroundColor: "#FFE58F",
            padding: "0 2px",
            borderRadius: 3,
            fontWeight: 600,
          }}
        >
          {part}
        </span>
      ) : (
        <span key={i}>{part}</span>
      )
    );
  };

  const handleClickedNoError = () => {
    setShowErrorInput(false);
    onChange({
      value,
      status: "reviewed",
      error: null,
    });
    // requestAnimationFrame(() => {
    //   const nextIndex = getNextCurrentIndex();
    //   if (nextIndex !== -1) {
    //     // cache.current.clear(nextIndex);
    //     // listRef.current.recomputeRowHeights(nextIndex);
    //     listRef.current.scrollToRow(nextIndex);
    //   }
    // });

    toast.success("Marked as reviewed");
  };

  const handleClickedError = () => {
    setShowErrorInput(true);
    setErrorText(error || "");
    if (onErrorToggle) onErrorToggle();
  };

  const handleSubmitError = () => {
    if (errorText.trim()) {
      onChange({
        value,
        status: "error",
        error: errorText,
        _openErrorInput: false,
      });
      setShowErrorInput(false);
      if (onErrorToggle) onErrorToggle();
    } else {
      toast.error("Please enter error description");
    }
  };

  const handleEditClick = () => {
    // Make this string current for editing
    onChange({
      value,
      status: "current",
      error,
    });
  };

  // const handleBlur = () => {
  //   setIsEditing(false);
  //   onChange({
  //     value,
  //     status: type,
  //     error,
  //   });
  // };

  const getStyleByType = (type, stringValue) => {
    const eventData = getEventFromString(stringValue);
    
    // Helper to darken background for dark mode
    const adjustBg = (color) => isDarkMode ? `${color}40` : color;
    const adjustText = (color) => isDarkMode ? "#ffffff" : "#000000";

    switch (type) {
      case "error":
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#DA1414",
          backgroundColor: isDarkMode ? "#451010" : "#FEEFEF",
          textColor: isDarkMode ? "#ff8a8a" : "#DA1414",
          iconColor: "#DA1414",
          badgeColor: isDarkMode ? "#451010" : "#f6e3e3ff",
          status: "Error",
        };
      case "current":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#1A56DB",
          backgroundColor: isDarkMode ? "#1e3a8a" : "#E1EFFE",
          textColor: isDarkMode ? "#bfdbfe" : "#000000",
          iconColor: "#1A56DB",
        };
      case "fixed":
        return {
          statusIcon: FaCheckCircle,
          borderColor: "#287D3C",
          backgroundColor: isDarkMode ? "#10451d" : "#EDF9F0",
          textColor: isDarkMode ? "#8ae59e" : "#287D3C",
          iconColor: "#287D3C",
          badgeColor: isDarkMode ? "#10451d" : "#d9f2ddff",
          status: "Fixed",
        };
      case "upcoming":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "var(--border-1)",
          backgroundColor: "var(--surface-2)",
          textColor: "var(--text-2)",
          iconColor: "var(--text-2)",
        };
      case "reviewed":
      default:
        if (eventData) {
          return {
            statusIcon: FaCheckCircle,
            borderColor: eventData.color,
            backgroundColor: adjustBg(eventData.bgColor),
            textColor: adjustText(eventData.color),
            iconColor: eventData.color,
            eventLabel: eventData.label,
            status: "Reviewed",
            badgeColor: isDarkMode ? `${eventData.color}22` : `${eventData.color}22`,
          };
        }
        return {
          statusIcon: FaCheckCircle,
          borderColor: "#287D3C",
          backgroundColor: isDarkMode ? "#10451d" : "#EDF9F0",
          textColor: isDarkMode ? "#8ae59e" : "#287D3C",
          iconColor: "#287D3C",
          badgeColor: isDarkMode ? "#10451d" : "#d9f2ddff",
          status: "No issue",
        };
    }
  };

  const {
    borderColor,
    statusIcon,
    backgroundColor,
    badgeColor,
    textColor,
    iconColor,
    status,
  } = getStyleByType(type, value);

  const reduceTimeBySeconds = (timeString, secondsToReduce) => {
    const hours = parseInt(timeString.split(":")[0]);
    const minutes = parseInt(timeString.split(":")[1]);
    const seconds = parseInt(timeString.split(":")[2].split(".")[0]);

    let totalSeconds = hours * 3600 + minutes * 60 + seconds - secondsToReduce;
    if (totalSeconds < 0) totalSeconds = 0;

    const newHours = Math.floor(totalSeconds / 3600);
    const newMinutes = Math.floor((totalSeconds % 3600) / 60);
    const newSeconds = totalSeconds % 60;

    return `${newHours.toString().padStart(2, "0")}:${newMinutes
      .toString()
      .padStart(2, "0")}:${newSeconds.toString().padStart(2, "0")}`;
  };

  const jumpManuallyViaString = () => {
    jumpManually(reduceTimeBySeconds(value.split("-")[6], 2));
  };

  return (
    <Stack>
      {/* Tag Box */}
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "5px",
          alignItems: "baseline",
          width: "100%",
          marginBottom: "5px",
          justifyContent: "center",
        }}
      >
        <Stack
          sx={{
            backgroundColor,
            borderRadius: "8px",
            paddingX: "12px",
            paddingY: "10px",
            border: `1px solid ${borderColor}`,
            minHeight: "30px",
            width: "100%",
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 400,
              color: textColor,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            {React.createElement(statusIcon, { color: iconColor })}
            <span>{highlightText(value, searchValue)}</span>
          </Typography>

          {type !== "upcoming" && (
            <Stack
              style={{ flexDirection: "row", alignItems: "center", gap: 10 }}
            >
              <TouchableOpacity onPress={jumpManuallyViaString}>
                <FaVideo color={iconColor} />
              </TouchableOpacity>
              {isFixed && (
                <Stack
                  style={{
                    padding: "0.2rem 0.4rem",
                    alignItems: "center",
                    gap: 6,
                    borderWidth: "2px",
                    borderRadius: 5,
                    backgroundColor: "#287D3C",
                    borderColor: "#287D3C",
                  }}
                >
                  <Typography
                    style={{
                      color: "white",
                      fontSize: 12,
                    }}
                  >
                    Fixed
                  </Typography>
                </Stack>
              )}
              {/* Buttons only for CURRENT */}
              {type === "current" ? (
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <TouchableOpacity
                    style={{
                      paddingHorizontal: 8,
                      paddingVertical: 4,
                      borderRadius: 6,
                      borderWidth: 1,
                      borderColor: "#9B1C1C",
                      marginLeft: 6,
                      backgroundColor: isDarkMode ? "#451010" : "#FDE8E8",
                    }}
                    onPress={handleClickedError}
                  >
                    <Typography
                      style={{
                        color: isDarkMode ? "#ff8a8a" : "#9B1C1C",
                        fontSize: 12,
                      }}
                    >
                      Error
                    </Typography>
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={{
                      paddingHorizontal: 8,
                      paddingVertical: 4,
                      borderRadius: 6,
                      borderWidth: 1,
                      borderColor: "#03543F",
                      marginLeft: 6,
                      backgroundColor: isDarkMode ? "#10451d" : "#DEF7EC",
                    }}
                    onPress={handleClickedNoError}
                  >
                    <Typography
                      style={{
                        color: isDarkMode ? "#8ae59e" : "#03543F",
                        fontSize: 12,
                      }}
                    >
                      No Error
                    </Typography>
                  </TouchableOpacity>
                </View>
              ) : (
                // Badge
                <Stack
                  style={{
                    flexDirection: "row",
                    padding: "0.2rem 0.4rem",
                    alignItems: "center",
                    gap: 6,
                    borderRadius: 5,
                    backgroundColor: badgeColor,
                  }}
                >
                  <Typography
                    style={{
                      color: iconColor,

                      fontSize: 12,
                    }}
                  >
                    {status}
                  </Typography>
                  <TouchableOpacity
                    onPress={handleEditClick}
                    style={{
                      padding: "0.2rem 0.4rem",
                      borderRadius: 4,
                    }}
                  >
                    <FaEdit color={iconColor} size={14} />
                  </TouchableOpacity>
                </Stack>
              )}
            </Stack>
          )}
        </Stack>
      </Stack>

      {/* ERROR INPUT BOX */}
      {showErrorInput && (
        <Stack
          style={{
            width: "94%",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: 8,
            padding: 12,
            backgroundColor: isDarkMode ? "#451010" : "#FEF2F2",
            borderRadius: 8,
            border: isDarkMode ? "1px solid #9B1C1C" : "1px solid #FCA5A5",
          }}
        >
          <Typography
            style={{
              fontSize: 12,
              color: isDarkMode ? "#ff8a8a" : "#991B1B",
              marginBottom: 8,
            }}
          >
            {error ? "Edit Error Comment:" : "Provide Error Details:"}
          </Typography>

          <Stack style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
            <TextInput
              ref={errorInputRef}
              style={{
                flex: 1,
                padding: 8,
                fontSize: 14,
                border: isDarkMode ? "1px solid #9B1C1C" : "1px solid #FCA5A5",
                borderRadius: 6,
                backgroundColor: "var(--surface-1)",
                color: "var(--text-1)",
                outline: "none",
              }}
              value={errorText}
              onKeyPress={(e) => {
                if (e.nativeEvent.key === "Enter") {
                  e.preventDefault();
                  handleSubmitError();
                }
              }}
              onChangeText={setErrorText}
              placeholder="Enter error description..."
            />

            <TouchableOpacity onPress={handleSubmitError}>
              <Typography
                style={{ color: "#03543F", fontSize: 14, fontWeight: "600" }}
              >
                <FaCheck />
              </Typography>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => {
                setShowErrorInput(false);
                setErrorText(error || "");
                onChange({
                  value,
                  status: type,
                  error,
                  _openErrorInput: false,
                });
                // if (onErrorToggle) onErrorToggle();
              }}
            >
              <Typography
                style={{ color: "#DC2626", fontSize: 14, fontWeight: "600" }}
              >
                <FaTimes />
              </Typography>
            </TouchableOpacity>
          </Stack>
        </Stack>
      )}

      {/* ERROR COMMENT DISPLAY */}
      {error && (
        <Stack
          sx={{
            padding: "12px",
            backgroundColor: isDarkMode ? "#000" : "#FEEFEF",
            color: isDarkMode ? "#fff" : "#DA1414",
            width: "95%",
            marginBottom: 1,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: "8px",
            border: isDarkMode ? "1px solid #374151" : "1px solid #FCA5A5",
          }}
        >
          <Typography
            style={{
              fontSize: 12,
              color: isDarkMode ? "#fff" : "#DA1414",
              textAlign: "justify",
              marginRight: "6px",
            }}
          >
            <b>My Comment:</b> {error}
          </Typography>

          <TouchableOpacity
            onPress={() => {
              setShowErrorInput(true);
              setErrorText(error || "");
              if (onErrorToggle) onErrorToggle();
            }}
          >
            <FaEdit color={isDarkMode ? "#fff" : "#DC2626"} />
          </TouchableOpacity>
        </Stack>
      )}
    </Stack>
  );
};

const FilterButtons = ({ active, setActive }) => {
  const filters = [
    { label: "All", value: "all" },
    { label: "Reviewed", value: "reviewed" },
    { label: "Errors", value: "error" },
    { label: "Pending", value: "pending" },
    { label: "Fixed", value: "fixed" },
  ];

  return (
    <div
      style={{
        display: "flex",
        gap: 8,
        marginTop: 8,
        overflowX: "auto",
        overflowY: "hidden",
        paddingBottom: 8,
        width: "100%",
        maxWidth: "100%",
      }}
    >
      {filters.map(({ label, value }) => {
        const isActive = active === value;

        return (
          <button
            key={value}
            type="button"
            onClick={() => setActive(value)}
            style={{
              backgroundColor: isActive ? "#FF5A1F" : "var(--surface-2)",
              borderRadius: 6,
              flex: "0 0 auto",
              padding: "0 10px",
              height: "28px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: isActive ? "none" : "1px solid var(--border-1)",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            <span
              style={{
                color: isActive ? "#fff" : "var(--text-1)",
                fontSize: 12,
                fontWeight: "500",
              }}
            >
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

const LegendTooltipIcon = () => {
  const grouped = {
    passing: [],
    shooting: [],
    defending: [],
    goalkeeping: [],
  };

  Object.entries(EVENT_MAP).forEach(([key, val]) => {
    grouped[val.group].push({ code: key, ...val });
  });

  return (
    <Tooltip
      arrow
      placement="left"
      title={
        <Box
          sx={{
            maxHeight: 260,
            overflowY: "auto",
            p: 1,
          }}
        >
          {/* PASSING */}
          <GroupLabel title="Passing (Green tones)" />
          {grouped.passing.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* SHOOTING */}
          <GroupLabel title="Shooting (Red / Orange tones)" mt />

          {grouped.shooting.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* DEFENDING */}
          <GroupLabel title="Defending (Blue tones)" mt />

          {grouped.defending.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* GK */}
          <GroupLabel title="Goalkeeping (Purple / Amber)" mt />

          {grouped.goalkeeping.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}
        </Box>
      }
      componentsProps={{
        tooltip: {
          sx: {
            background: "var(--surface-1)",
            borderRadius: "8px",
            maxWidth: 260,
            p: 1,
            border: "1px solid var(--border-1)",
          },
        },
      }}
    >
      <IconButton size="small">
        <InfoOutlinedIcon fontSize="small" sx={{ color: "var(--text-1)" }} />
      </IconButton>
    </Tooltip>
  );
};

const GroupLabel = ({ title, mt }) => (
  <Typography
    fontWeight={700}
    fontSize={12}
    sx={{ mt: mt ? 1 : 0.2, mb: 0.5, opacity: 0.9, color: "var(--text-1)" }}
  >
    {title}
  </Typography>
);

const LegendRow = ({ item }) => (
  <Stack direction="row" alignItems="center" spacing={1} mb={0.4}>
    {/* Color box */}
    <Box
      sx={{
        width: 12,
        height: 12,
        borderRadius: "3px",
        background: item.color,
      }}
    />

    <Typography sx={{ width: 48, fontSize: 12, fontWeight: 600, color: "var(--text-1)" }}>
      {item.code}
    </Typography>

    <Typography sx={{ fontSize: 12, opacity: 0.8, color: "var(--text-1)" }}>{item.label}</Typography>
  </Stack>
);

const styles = {
  header: {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: 60,
      backgroundColor: "var(--surface-1)",
      padding: "0 16px",
      boxShadow: "0px 2px 6px var(--border-1)",
      zIndex: 10,
    },
    side: {
      width: 60,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    center: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 8,
    },
    score: {
      color: "#1C64F2",
      fontWeight: "bold",
      fontSize: 16,
    },
    matchInfo: {
      textAlign: "center",
      color: "var(--text-1)",
    },
    matchTitle: {
      fontSize: 16,
      fontWeight: 700,
      color: "var(--text-1)",
    },
    matchSub: {
      fontSize: 12,
      color: "var(--text-2)",
    },
    logout: {
      color: "#FF5A1F",
      cursor: "pointer",
      fontWeight: "500",
    },
  },

  cardContainer: {
    display: "flex",
    gap: 10,
    padding: 20,
  },

  card1: {
    card: {
      flex: 1,
      height: 80,
      borderRadius: 8,
      backgroundColor: "var(--surface-1)",
      boxShadow: "0 4px 12px var(--border-1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      display: "flex",
      width: "90%",
      justifyContent: "space-around",
    },
    team: {
      display: "flex",
      flexDirection: "column",
      gap: 12,
      width: "50%",
    },
    teamNameText: {
      fontWeight: "bold",
      fontSize: 14,
      textAlign: "center",
      marginBottom: 4,
      color: "var(--text-1)",
    },
    teamBoxA: {
      backgroundColor: "rgba(231, 245, 236, 0.2)",
      padding: "4px 16px",
      borderRadius: 4,
      alignItems: "flex-start",
    },
    teamBoxB: {
      backgroundColor: "rgba(229, 245, 252, 0.2)",
      padding: "4px 16px",
      borderRadius: 4,
      alignItems: "flex-end",
    },
    label: {
      fontWeight: 400,
      textAlign: "center",
      fontSize: 14,
      color: "var(--text-2)",
    },
  },

  card2: {
    card: {
      flex: 1,
      height: 80,
      borderRadius: 8,
      backgroundColor: "var(--surface-1)",
      boxShadow: "0 4px 12px var(--border-1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      width: "90%",
      display: "flex",
      alignItems: "center",
      gap: 20,
    },
    box: {
      backgroundColor: "rgba(12, 157, 65, 0.1)",
      padding: "16px 10px",
      borderRadius: 8,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    id: {
      fontWeight: 500,
      fontSize: 18,
      color: "var(--text-1)",
    },
    textRight: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
    },
    name: {
      fontSize: 16,
      fontWeight: 700,
      color: "var(--text-1)",
    },
    label: {
      fontSize: 10,
      color: "var(--text-2)",
      fontWeight: 500,
    },
  },

  card3: {
    card: {
      backgroundColor: "var(--surface-1)",
      borderRadius: 12,
      border: "1px solid var(--border-1)",
      padding: 16,
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      boxShadow: "0px 2px 8px var(--border-1)",
    },
    row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "90%",
      gap: 20,
    },
    title: {
      fontWeight: 600,
      color: "var(--text-2)",
      fontSize: 18,
    },
    time: {
      color: "#FF5A1F",
      fontWeight: 500,
      fontSize: 16,
    },
    progressBar: {
      width: 60,
    },
    timeProgressWrapper: {
      display: "flex",
      alignItems: "center",
      gap: 20,
    },
  },

  urlCard: {
    wrapper: {
      padding: 10,
      borderRadius: 12,
      backgroundColor: "var(--surface-1)",
      boxShadow: "0 2px 6px var(--border-1)",
      margin: "0 20px",
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 20,
    },
    label: {
      fontWeight: 500,
      fontSize: 16,
      whiteSpace: "nowrap",
      color: "var(--text-1)",
    },
    inputGroup: {
      display: "flex",
      border: "1px solid var(--border-1)",
      borderRadius: 8,
      overflow: "hidden",
      width: "30%",
    },
    input: {
      flex: 1,
      padding: "10px 12px",
      border: "none",
      outline: "none",
      fontSize: 14,
      backgroundColor: "transparent",
      color: "var(--text-1)",
    },
    button: {
      backgroundColor: "#FF5A1F",
      border: "none",
      padding: "0 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
  },

  container: {
    flex: 1,
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    backgroundColor: "var(--surface-1)",
    marginBottom: "1rem",
  },
  videoContainer: {
    width: "100%",
    borderRadius: 10,
    border: "1px solid var(--border-1)",
    backgroundColor: "var(--surface-1)",
    overflow: "hidden",
  },

  videoTimeline: {
    paddingTop: 4,
    paddingBottom: 4,
    paddingHorizontal: "8px",
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "var(--surface-2)",
    borderTop: "1px solid var(--border-1)",
  },

  controlContainer: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    backgroundColor: "var(--surface-1)",
    borderTop: "1px solid var(--border-1)",
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "11px",
    paddingBottom: "11px",
  },
  leftControl: {
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    gap: "2px",
  },
  middleControl: {
    alignItems: "center",
  },
  rightControl: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
  },
};

const mapStateToProps = (state) => {
  return {
    videoControl: state.control.videoControl,
    videoUrl: state.control.videoUrl,
    videoTime: state.control.videoTime,
    all_matches: state.match.all_matches,
    currentAction: state.control.currentAction,
    analysedString: state.control.analysedString,
    actionLog: state.control.actionLog,
    seekToTime: state.control.seekToTime,
    analystId: state.auth.analyst_id,
  };
};

export default connect(mapStateToProps, {
  UpdateVideoTime,
  LoadVideoUrl,
  SetVideoControl,
  SetControllerToggle,
  ClearSeekFlag,
})(ReviewPortal);
